export default "__VITE_ASSET__28c0888a__"